var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-select',{attrs:{"value":_vm.value,"label":"Idioma","items":_vm.langs,"item-text":"name","return-object":"","rules":_vm.rules,"loading":_vm.isLoading},on:{"change":_vm.emitInput}})
}
var staticRenderFns = []

export { render, staticRenderFns }